import { useCallback } from 'react';
import { useStoresApi } from '../api';

export const useCheckCoupon = (): ((coupon?: string) => Promise<boolean>) => {
  const storesApi = useStoresApi();

  const checkCoupon = async (coupon?: string): Promise<boolean> => {
    if (!coupon) return false;

    try {
      const stores = await storesApi.getStoreByCouponCode(coupon);
      return stores.length === 1;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  return useCallback(checkCoupon, [storesApi]);
};
